import PageContentWrapper from '../layout/PageContentWrapper'
import StyledAdditionalNotifyMethod from './StyledAdditionalNotifyMethod'

const StyledConfiguration = () => {
    return (
        <PageContentWrapper className={'p-4'}>
            <div className="" style={{minHeight: 'calc(100vh - 8rem)'}}>
                <h3 className="pt-2 mb-0 text-darkcyan font-bold text-3xl md:text-4xl ">
                    Configuration
                </h3>
                <i
                    className="underline text-700 text-md font-normal "
                    style={{width: '40rem'}}>
                    The process of setting up system settings and options to
                    ensure it operates according to predefined requirements.
                </i>
                <hr />

                <StyledAdditionalNotifyMethod />
            </div>
        </PageContentWrapper>
    )
}

export default StyledConfiguration
